module.exports = __webpack_public_path__ + "img/symbol_9.d0a2b175.png";